import { Box, Column, Columns, Table, Tabs } from "@allxsmith/bestax-bulma";
import React from "react";
import {readableDate} from "../../utils";
import Figure from "../Homepage/Figure";

export const InsuranceView = ({rentals, current, count, onPageChange, onViewChange, view, total_long_term, total_short_term}) => {

  return (
    <Box>
      <h1 className={"title"}>Upcoming Insurance Expiries</h1>
      <Columns isMultiline>
            <Column>
                <Figure label="Total Estimated Long Term Weekly Rate" value={total_long_term} loaded={total_long_term}/>
            </Column>
            <Column>
                <Figure label="Total Estimated Short Term Weekly Rate" value={total_short_term} loaded={total_short_term}/>
            </Column>
      </Columns>
      <Tabs align="centered" toggle>
        <Tabs.List>
          <Tabs.Item active={view === "all"}><a onClick={() => onViewChange("all")}>All
                      </a></Tabs.Item>
          <Tabs.Item active={view === "all_hire"}><a onClick={() => onViewChange("all_hire")}>All On Hire
                      </a></Tabs.Item>
          <Tabs.Item active={view === "weekly"}><a onClick={() => onViewChange("weekly")}>Weekly
                      </a></Tabs.Item>
          <Tabs.Item active={view === "onhires"}><a onClick={() => onViewChange("onhires")}>Upcoming Onhires
                      </a></Tabs.Item>
          <Tabs.Item active={view === "offhires"}><a onClick={() => onViewChange("offhires")}>Upcoming Offhires
                      </a></Tabs.Item>
          <Tabs.Item active={view === "insurance"}><a onClick={() => onViewChange("insurance")}>Insurance Expiries
                      </a></Tabs.Item>
          <Tabs.Item active={view === "unfinished_off"}><a onClick={() => onViewChange("unfinished_off")}>Unfinished Offhires
                      </a></Tabs.Item>
          <Tabs.Item active={view === "over_mileage"}><a onClick={() => onViewChange("over_mileage")}>Over Mileage
                      </a></Tabs.Item>
          <Tabs.Item active={view === "awaiting_quote"}><a onClick={() => onViewChange("awaiting_quote")}>Awaiting Estimate
                      </a></Tabs.Item>
          <Tabs.Item active={view === "quotes"}><a onClick={() => onViewChange("quotes")}>Quotes
                      </a></Tabs.Item>
          <Tabs.Item active={view === "nr"}><a onClick={() => onViewChange("nr")}>Not Required
                      </a></Tabs.Item>
        </Tabs.List>
      </Tabs>
      <Table>
        <thead>
        <tr>
          <th>Registration</th>
          <th>Customer</th>
          <th>Make</th>
          <th>Model</th>
          <th>Insurancy Expiry</th>
        </tr>
        </thead>
        <tbody>
        {rentals.map((value, index) => (
          <tr
            className="clickable"
            onClick={() => window.open(`/editrental/${value.id}`, "_self")}
            key={value.id}
          >
            <td>{value.vehicle.registration}</td>
            <td>{value.customer.display_name}</td>
            <td>{value.vehicle.make.name}</td>
            <td>{value.vehicle.model.name}</td>
            <td>{readableDate(value.insurance_expiry)}</td>
          </tr>
        ))
        }
        </tbody>
      </Table>
      {/*<Pagination*/}
      {/*    showFirstLast={true}*/}
      {/*    onChange={page => onPageChange(page)}*/}
      {/*    current={current}*/}
      {/*    total={Math.ceil(count / 25)}*/}
      {/*  />*/}
    </Box>
  );
}